import { useState, Fragment, useEffect } from 'react';
import notificationIcon from '../../assets/icons/notification.svg';
import whiteTriangleIcon from '../../assets/icons/white_triangle.svg';
import BellIcon from '../../assets/svg/BellIcon.svg';
import { Menu, Transition } from '@headlessui/react';
import { DefaultItem, EmailItem } from './Items';
import useAuthContext from '../../hooks/useAuthContext';
import { useNavigate } from 'react-router-dom';
import { EMAIL_CONFIRMATION } from '../../routes/app/paths';
import usePusher from '../../hooks/usePusher';
import queryNotification from '../../services/notification/queryNotification';
import { useToast } from '@chakra-ui/toast';

const notificationActions = {
  Test: (data) => console.log('console-log', data), //TODO: agregar acciones cuando el usuario da click en la notificacion, a especificacion del dueño de la app
};

const Notification = () => {
  /* Hooks */
  const navigate = useNavigate();

  /* States */
  const [notifData, setNotifData] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const { user, isAuthenticated } = useAuthContext();

  const notif = usePusher();
  const toast = useToast();
  const queryNotif = queryNotification();
  const { data: endpointNotif } = queryNotif.listNotification();

  /* Effects */
  useEffect(() => {
    if (isAuthenticated && !user?.email_verified_at) {
      const notifcationsWithoutEmailVerification = notifData.filter(
        (notif) => notif.type !== 'emailVerification',
      );
      setNotifData([
        {
          type: 'emailVerification',
          message: 'Por favor, verifique su correo',
          onClick: () => navigate(EMAIL_CONFIRMATION),
        },
        ...notifcationsWithoutEmailVerification,
      ]);
    } else {
      // remove email verification notification
      const notifcationsWithoutEmailVerification = notifData.filter(
        (notif) => notif.type !== 'emailVerification',
      );
      setNotifData(notifcationsWithoutEmailVerification);
    }
  }, [isAuthenticated, user?.email_verified_at]);

  useEffect(() => {
    if (notif) {
      const notifToAdd = notif?.data || notif;
      const notifArray = Array.isArray(notifToAdd) ? notifToAdd : [notifToAdd];
      
      setNotifData((prev) => {
        const notifIds = new Set(prev.map(n => n.id).filter(Boolean));
        const newNotifs = notifArray.filter(n => !n.id || !notifIds.has(n.id));
        return [...newNotifs, ...prev];
      });
      
      queryNotif.addCache(notifArray)
      toast({
        title: notif?.data?.title || notif.title,
        description: notif?.data?.body || notif.body,
        status: 'info',
        duration: 2000,
        position: 'top-right',
        isClosable: true,
      });
    }
  }, [notif]);

  useEffect(() => {
    if (endpointNotif?.length && !isInitialized) {
      setNotifData(endpointNotif);
      setIsInitialized(true);
      if (endpointNotif.length === 1 && !endpointNotif[0].read)
        toast({
          title: endpointNotif[0].title,
          description: endpointNotif[0].body,
          status: 'info',
          duration: 4000,
          position: 'top-right',
          isClosable: true,
        });
      if (
        endpointNotif.length > 1 &&
        !endpointNotif.some((notif) => !notif.read)
      ) {
        toast({
          title: 'Tienes notificaciones',
          description: 'Revisa tus notificaciones',
          status: 'info',
          duration: 4000,
          position: 'top-right',
          isClosable: true,
        });
      }
    }
  }, [endpointNotif, isInitialized]);

  /* Functions */
  const hasUnreadNotifications = notifData.some((notif) => !notif.read);

  if (!isAuthenticated) return null;

  return (
    <Menu as="div" className="relative">
      <Menu.Button>
        <img
          className="mt-2 w-6 h-6 rounded-full hover:shadow-md"
          src={BellIcon}
          alt="notification"
        />
        {/* red dot */}
        {notifData.length > 0 && hasUnreadNotifications && (
          <>
            <div
              className="w-2 h-2 pointer-events-none aspect-square rounded-full bg-bubble-gum ml-1 absolute right-1 top-1"
              aria-label="Tienes notificaciones sin leer"
              role="status"
            >
              <span className="sr-only">Tienes notificaciones sin leer</span>
            </div>
          </>
        )}
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute flex flex-col gap-2 p-5 right-0 mt-2 min-w-[230px] max-w-sm origin-top-right rounded-md bg-white shadow-lg focus:outline-none z-50">
          <img
            src={whiteTriangleIcon}
            alt=""
            className="absolute right-2 -mt-7"
          />

          {notifData.length === 0 && (
            <span className="text-xs text-gray-500">No hay notificaciones</span>
          )}
          {notifData.map((notif, index) => {
            if (notif?.type === 'emailVerification')
              return (
                <EmailItem key={`notif-${index}`} onClick={notif.onClick} />
              );
            return (
              <DefaultItem
                key={`notif-${index}`}
                notification={notif}
                onClick={notificationActions[notif.type]}
              />
            );
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default Notification;
